import { Subscription } from "rxjs/Subscription";
import {
  Component,
  OnInit,
  AfterViewInit,
  ViewChildren,
  QueryList,
  ViewChild,
  ElementRef,
} from "@angular/core";
import { ChartDataSets, ChartOptions } from "chart.js";
import { Color } from "ng2-charts";
import { SlimLoadingBarService } from "ng2-slim-loading-bar";
import { HttpClient, HttpParams } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { Router } from "@angular/router";
import { Calendar } from "@fullcalendar/core";
import dayGridPlugin from "@fullcalendar/daygrid";
import { ReservationService } from "../../services/reservation-service/reservation.service";
import { removeNullishFieldsParams } from "../../shared/object_helpers";
@Component({
  selector: "app-user-dashboard",
  templateUrl: "./user-dashboard.component.html",
  styleUrls: ["./user-dashboard.component.scss"],
  providers: [SlimLoadingBarService],
})
export class UserDashboardComponent implements OnInit, AfterViewInit {
  //#region  Definitions
  channels: any;
  selectedChannel: any;

  projects: any;
  users: [];
  selectedUser: any = {};
  selectedYear: any = {};
  selectedMonth: any = {};
  waletTarget: any;
  rangeDates: Date[];

  userData: any;

  statsData: any = {
    leadStatusStats: null,
    salesPipelineStats: null,
    inventoryStats: null,
    activityStats: null,
  };

  lineChartsData: {
    salesActivity: ChartDataSets[];
    monthlySales: ChartDataSets[];
  } = {
    salesActivity: [],
    monthlySales: [],
  };

  lineChartsLabels = {
    salesActivity: [],
    monthlySales: [],
  };

  lineChartsOptions: {
    salesActivity: ChartOptions;
    monthlySales: ChartOptions;
  } = {
    salesActivity: {
      responsive: true,
      maintainAspectRatio: false,
      elements: {
        line: {
          fill: false,
          tension: 0,
        },
      },
    },
    monthlySales: {
      responsive: true,
      maintainAspectRatio: false,
      elements: {
        line: {
          fill: false,
        },
      },
    },
  };

  lineChartsColors: { salesActivity: Color[]; monthlySales: Color[] } = {
    salesActivity: [
      {
        // green
        backgroundColor: "green",
        borderColor: "green",
        pointBackgroundColor: "#fff",
        pointBorderColor: "green",
        pointHoverBackgroundColor: "green",
        pointHoverBorderColor: "#fff",
      },
      {
        // blue
        backgroundColor: "blue",
        borderColor: "blue",
        pointBackgroundColor: "#fff",
        pointBorderColor: "blue",
        pointHoverBackgroundColor: "blue",
        pointHoverBorderColor: "#fff",
      },
      {
        // magenta
        backgroundColor: "magenta",
        borderColor: "magenta",
        pointBackgroundColor: "#fff",
        pointBorderColor: "magenta",
        pointHoverBackgroundColor: "magenta",
        pointHoverBorderColor: "#fff",
      },
      {
        // aqua
        backgroundColor: "aqua",
        borderColor: "aqua",
        pointBackgroundColor: "#fff",
        pointBorderColor: "aqua",
        pointHoverBackgroundColor: "aqua",
        pointHoverBorderColor: "#fff",
      },
    ],
    monthlySales: [
      {
        // purple
        backgroundColor: "purple",
        borderColor: "purple",
        pointBackgroundColor: "#fff",
        pointBorderColor: "purple",
        pointHoverBackgroundColor: "purple",
        pointHoverBorderColor: "#fff",
      },
    ],
  };

  @ViewChildren("newsElementContainer") newsElement: QueryList<any>;
  newsIsLoading = true;
  shoroukNewsIsLoading = false;
  mubasherNewsIsLoading = false;
  almasryNewsIsLoading = false;
  almalNewsIsLoading = false;

  newsChangesSubscription: Subscription;

  newsData: any;
  activeYear = new Date().getFullYear();
  selectedQuarter: any = {};
  quarterList: any[] = [
    {
      value: 1,
      name: "First Quarter",
    },
    {
      value: 2,
      name: "Second Quarter",
    },
    {
      value: 3,
      name: "Third Quarter",
    },
    {
      value: 4,
      name: "Fourth Quarter",
    },
  ];
  walletTarget: any;
  selectedProject_filter: any;

  //#endregion

  constructor(
    private slimLoadingBarService: SlimLoadingBarService,
    private reservationService: ReservationService,
    private http: HttpClient,
    private router: Router
  ) {}

  ngOnInit() {
    this.userData = JSON.parse(localStorage.getItem("userProfile"));

    this.getUsers();
    this.getInitialFilter();
    this.getLeadChannels();
    this.getListProjects();
    this.filterDashboard();
    this.getChartsSalesActivities();
    this.getChartsSalesReservations();
    this.getNews();
    this.getReminders();
    this.initCalender();
  }
  getReminders() {
    this.http.get(`${environment.api_base_url}get_coming_reminders`).subscribe(
      (data: any) => {
        this.raw_events = data;
        this.calendar_events = data.map((reminder) => ({
          id: reminder.id,
          title: `${reminder.title ? reminder.title : ""}: ${
            reminder.desc ? reminder.desc : ""
          }${reminder.lead ? ` (${reminder.lead.name})` : ""}`,
          start: reminder.datetime,
          backgroundColor: reminder.action ? reminder.action.color : undefined,
          classNames: reminder.is_done ? ["done"] : [],
        }));
        this.initCalender();
      },
      (err) => {
        console.log(err);
      }
    );
  }

  //#region get methods
  getLeadChannels() {
    this.http.get(`${environment.api_base_url}lead_channels`).subscribe(
      (data) => {
        this.channels = data;
      },
      (err) => {
        console.log(err);
      }
    );
  }

  getListProjects() {
    this.reservationService.getProjects({ is_select_form: true }).subscribe(
      (data) => {
        this.projects = data;
      },
      (err) => {
        console.log(err);
      }
    );
  }

  getChartsSalesActivities() {
    this.http
      .get(`${environment.api_base_url}dashboard/charts/sales_activity`)
      .subscribe(
        (data: any) => {
          this.lineChartsLabels.salesActivity = [...data.months];
          this.lineChartsData.salesActivity = [...data.results];
        },
        (err) => {
          console.log(err);
        }
      );
  }

  getChartsSalesReservations() {
    this.http
      .get(`${environment.api_base_url}dashboard/charts/sales_reservations`)
      .subscribe(
        (data: any) => {
          this.lineChartsLabels.monthlySales = [...data.months];
          this.lineChartsData.monthlySales = [...data.results];
        },
        (err) => {
          console.log(err);
        }
      );
  }

  getNews() {}

  getQuarter(month: number) {
    // Validate input
    if (typeof month !== 'number' || month < 1 || month > 12 || !Number.isInteger(month)) {
      return null;
    }

    // Calculate quarter (1-4)
    const quarterValue = Math.ceil(month / 3);

    // Find and return the quarter object
    return this.quarterList.find(q => q.value === quarterValue) || null;
  }

  getInitialFilter() {
    let date = new Date();
    this.selectedMonth = {
      value: date.getMonth() + 1,
      name: date.toLocaleDateString("en", { month: "long" }),
    };
    this.selectedYear = {
      value: date.getFullYear(),
      name: date.getFullYear(),
    };
    this.selectedQuarter = this.getQuarter(this.selectedMonth.value);
    this.getTarget( this.selectedYear.value, this.selectedQuarter.value);
  }

  getUsers() {
    this.http.get(`${environment.api_base_url}users/get_agents`).subscribe(
      (data: any) => {
        this.users = data;
        console.log("users : ", this.users);
      },
      (err) => {
        console.log(err);
      }
    );
  }

  getYears() {
    const now = new Date().getUTCFullYear();
    return Array(10)
      .fill("")
      .map((v, idx) => ({ name: now - idx, value: now - idx }));
  }

  getMonths() {
    let month = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    // let month = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul","Aug", "Sep", "Oct", "Nov", "Dec"];
    return month.map((v, idx) => ({ value: idx + 1, name: v }));
  }

  getTarget(year?: number, quarter?: number, project?: number, userId?: number) {
    let params: any = {
      quarter: quarter,
      year: year,
      project_id: project,
      user_id: userId,
    };
    params = removeNullishFieldsParams(params);
    this.http
      .get(`${environment.api_base_url}dashboard/current_target`, {
        params: Object.entries(params)
          .filter(([key, val]) => val !== undefined)
          .reduce((obj, [key, val]) => {
            obj[key] = `${val}`;
            return obj;
          }, {}),
      })
      .subscribe(
        (data) => {
          this.walletTarget = data;
          console.log("target : ", this.walletTarget);
        },
        (err) => {
          console.log(err);
        }
      );
  }
  //#endregion

  //#region onchange methods
  onChannelChange() {
    this.filterDashboard();
  }

  onChangeDatePicker() {
    console.log("date chanched");
    console.log(this.rangeDates);
    this.filterDashboard();
  }

  onChangeFilter(year?: any, quarter?: any, project?: any, user?: any) {
    this.selectedYear = year || "";
    this.selectedQuarter = quarter || "";
    this.selectedProject_filter = project || "";
    this.selectedUser = user || "";
    this.getTarget(
      this.selectedYear ? this.selectedYear.value : "",
      this.selectedQuarter ? this.selectedQuarter.value : "",
      this.selectedProject_filter ? this.selectedProject_filter.id : "",
      this.selectedUser ? this.selectedUser.id : ""
    );
  }

  //#endregion

  filterDashboard() {
    const params = {
      date_picker: JSON.stringify(this.rangeDates),
      channel_id: this.selectedChannel ? this.selectedChannel.id : "",
    };

    this.filterSalesPipeline(params);
    this.filterInventoryPipeline(params);
    this.filterActivity(params);
    this.filterLeadStatus(params);
  }

  filterLeadStatus(params) {
    this.http
      .get(`${environment.api_base_url}dashboard/leadStatusStats`, {
        params,
      })
      .subscribe((res) => {
        this.statsData.leadStatusStats = res;
      });
  }

  filterSalesPipeline(params) {
    this.http
      .get(`${environment.api_base_url}dashboard/salesPipelineStats`, {
        params,
      })
      .subscribe((res) => {
        this.statsData.salesPipelineStats = res;
      });
  }

  filterInventoryPipeline(params) {
    this.http
      .get(`${environment.api_base_url}dashboard/inventoryStats`, {
        params,
      })
      .subscribe((res) => {
        this.statsData.inventoryStats = res;
      });
  }

  filterActivity(params) {
    this.http
      .get(`${environment.api_base_url}dashboard/activityStats`, {
        params,
      })
      .subscribe((res) => {
        this.statsData.activityStats = res;
      });
  }

  onGoPageTop() {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  }

  ngAfterViewInit() {
    this.slimLoadingBarService.start();
    (<any>$(".owl-carousel")).owlCarousel({
      items: 1,
      loop: true,
      autoplay: true,
      autoplayTimeout: 2000,
    });
  }

  reloadNews(newsName) {
    if (newsName) {
      switch (newsName) {
        case "almalnews":
          this.almalNewsIsLoading = true;
          break;
        case "almasryalyoum":
          this.almasryNewsIsLoading = true;
          break;
        case "mubasher":
          this.mubasherNewsIsLoading = true;
          break;
        case "shorouknews":
          this.shoroukNewsIsLoading = true;
          break;
      }
    }
  }

  onLeadStatusClicked(lead_status) {
    if (!lead_status) {
      return;
    }

    const statusName = (lead_status.status || lead_status.name || "")
      .toString()
      .trim();
    const normalizedStatusName = statusName.toLowerCase();
    const isAllStatus =
      normalizedStatusName === "all" || normalizedStatusName === "total";
    if (isAllStatus) {
      this.router.navigate(["/pages/leads"]);
      return;
    }

    if (!statusName) {
      return;
    }

    const queryParams: any = {
      status_name: statusName,
    };
    if (lead_status.status_id || lead_status.id) {
      queryParams.status_id = lead_status.status_id || lead_status.id;
    }
    if (this.selectedChannel) {
      queryParams.channel = JSON.stringify(this.selectedChannel);
    }

    this.router.navigate(["/pages/leads"], {
      queryParams,
    });
  }

  goToLeadsWithActivity(lead_activity) {
    this.router.navigate(["/pages/leads"], {
      queryParams: {
        activity_name: lead_activity.title,
      },
    });
  }

  // calender manage
  @ViewChild("calendarEl") calendarEl: ElementRef;
  calendar: any;
  raw_events = [];
  calendar_events = [];
  selectedEvent = null;
  formDisplay: boolean | "view" = false;
  initCalender() {
    if (this.calendar) {
      this.calendar.destroy();
    }
    this.calendar = new Calendar(this.calendarEl.nativeElement, {
      plugins: [dayGridPlugin],
      headerToolbar: {
        left: "prev,next today",
        right: "title",
      },
      events: this.calendar_events,
      eventClick: (info) => {
        this.eventClicked(info);
      },
      eventDidMount: (doc) => {
        // Fix Calendar BUG: backgroundColor not set Correctly
        // set background color with opacity
        doc.el.style.cursor = "pointer";
        if (doc.event.backgroundColor) {
          doc.el.style.backgroundColor = doc.event.backgroundColor + 60;
        }
        if (doc.event.classNames.includes("done")) {
          doc.el.style.textDecoration = "line-through";
        }
      },
    });
    this.renderCalender();
  }

  renderCalender() {
    this.calendar.render();
  }

  eventClicked(info) {
    this.raw_events.forEach((event) => {
      if (event.id == info.event.id) {
        this.openForm(event, true);
      }
    });
  }

  openForm(event = null, view = false) {
    this.selectedEvent = event;
    this.formDisplay = view ? "view" : true;
  }

  getFirstNames(name = "N A") {
    if (!name) {
      return "NA";
    }
    return name
      .split(" ")
      .map((str) => str[0].toUpperCase())
      .join("");
  }
}



// WEBPACK FOOTER //
// ./src/app/dashboard/user-dashboard/user-dashboard.component.ts